module.exports = __webpack_public_path__ + "images/c41c570b4371add5d07ab82550116ad4.svg";